// extracted by mini-css-extract-plugin
module.exports = {"root":"LinkWithIcon_root__2q_7P","link":"LinkWithIcon_link__djH9c","icon":"LinkWithIcon_icon__wVXI8"};